/*
 * Authors: mariushirjanu
 * Created: 12/10/2021
 */
import { Injectable, ApplicationRef, ComponentFactoryResolver, ComponentRef, Injector, EmbeddedViewRef } from '@angular/core';

type ComponentType<T> = new (...args:any[]) => T;

// Allows to load the content of a component and insert it into the DOM element
@Injectable({ providedIn: 'root' })
export class DynamicComponentService {
  private components:ComponentRef<any>[] = [];

  constructor(
    private applicationRef:ApplicationRef,
    private componentFactoryResolver:ComponentFactoryResolver,
    private injector:Injector
  ) {
  }

  public add<T>(component:ComponentType<T> | ComponentRef<T>, element?:Element | string):ComponentRef<T> {
    const componentRef:ComponentRef<T> = component instanceof ComponentRef? component : this.componentFactoryResolver.resolveComponentFactory(component).create(this.injector);
    this.applicationRef.attachView(componentRef.hostView);
    if (typeof element === 'string') {
      element = document.querySelector(element);
    }
    if (!element) {
      element = document.body;
    }
    element.appendChild((componentRef.hostView as EmbeddedViewRef<any>).rootNodes[ 0 ]);
    this.components.push(componentRef);
    return componentRef;
  }

  public remove(component:number | ComponentRef<any>):boolean {
    let componentRef:ComponentRef<any>;
    if (typeof component === 'number' && this.components.length > component) {
      componentRef = this.components.splice(component, 1)[ 0 ];
    } else {
      for (const cr of this.components) {
        if (cr === component) {
          componentRef = cr;
        }
      }
    }
    if (componentRef) {
      this._remove(componentRef);
      return true;
    }
    return false;
  }

  private _remove(componentRef:ComponentRef<any>):void {
    this.applicationRef.detachView(componentRef.hostView);
    componentRef.destroy();
  }

  public getIndex(componentRef:ComponentRef<any>):number {
    return this.components.indexOf(componentRef);
  }

  public clear():void {
    while (this.components.length > 0) {
      this._remove(this.components.pop());
    }
  }
}